import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { minisiteGet } from '../utils/minisiteApi';
import MinisiteView from './MinisiteView';
import { getOccasion } from '../utils/minisiteOccasions';

// Page publique du mini-site de mariage (/i/:slug) : c'est le lien envoyé aux invités (cf.
// l'éditeur, MinisiteEditor.js). Plein écran, sans l'en-tête de la boutique (hideHeader, App.js).
const MinisitePage = () => {
  const { slug } = useParams();
  const [minisite, setMinisite] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    minisiteGet('getMinisite', { slug })
      .then((data) => (data?.success ? setMinisite(data.data) : setNotFound(true)))
      .catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return <p style={{ textAlign: 'center', padding: 48 }}>Page introuvable</p>;
  if (!minisite) return <p style={{ textAlign: 'center', padding: 48 }}>Chargement…</p>;

  const params = minisite.params || {};

  return (
    <>
      <Helmet>
        <title>{[params.prenoms, params.intro || getOccasion(params).intro].filter(Boolean).join(' — ')}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <MinisiteView params={params} slug={slug} />
    </>
  );
};

export default MinisitePage;
